import { PaymentTypeSwitchData } from "../../../types/ProductService/ProductService";
import * as stagesCase from "../../Stages/StagesCase";
import { LitigationUnion } from "../../../types/LitigationUnion";

export const placeholderPaymentTypeSwitchData: PaymentTypeSwitchData = {
  getPaymentSwitchAllowed: () => {
    return { allowed: true };
  },
  getActionAvailable: () => false,
  options: [],
};

export const litigationCaseCourtAppointmentCreationAvailable = <T extends LitigationUnion = LitigationUnion>(product: T) =>
  product.stage >= stagesCase.STAGE_LAWSUIT;
